function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.7002,
  cy: 100.576,
  rx: 13.5,
  ry: 2.42353,
  fill: "#C4C4C4",
  fillOpacity: 0.01
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 96.3353,
  rx: 24,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.1,
  width: 48,
  height: 96.3352,
  rx: 24,
  fill: "#00321E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.28604 35.658C5.28604 35.838 5.43004 36 5.62804 36H12.828C13.026 36 13.17 35.838 13.17 35.658V34.668C13.17 34.488 13.026 34.326 12.828 34.326H7.14004V30.456H11.946C12.126 30.456 12.288 30.312 12.288 30.114V29.106C12.288 28.926 12.126 28.764 11.946 28.764H7.14004V25.092H12.828C13.026 25.092 13.17 24.93 13.17 24.75V23.742C13.17 23.562 13.026 23.4 12.828 23.4H5.62804C5.43004 23.4 5.28604 23.562 5.28604 23.742V35.658ZM15.046 35.658C15.046 35.838 15.208 36 15.388 36H16.396C16.576 36 16.738 35.838 16.738 35.658V31.266C16.828 31.032 17.44 30.186 18.52 30.186C19.528 30.186 20.05 30.816 20.05 31.968V35.658C20.05 35.838 20.194 36 20.392 36H21.346C21.526 36 21.688 35.838 21.688 35.658V31.932C21.688 31.572 21.67 31.23 21.634 31.068C21.76 30.96 22.39 30.186 23.488 30.186C24.46 30.186 24.982 30.834 24.982 31.968V35.658C24.982 35.838 25.126 36 25.324 36H26.332C26.53 36 26.674 35.838 26.674 35.658V32.04C26.674 30.168 25.9 28.62 23.704 28.62C22.336 28.62 21.292 29.574 21.094 29.772C20.572 29.034 19.816 28.62 18.772 28.62C17.386 28.62 16.558 29.466 16.396 29.628L16.198 29.016C16.144 28.89 16.054 28.8 15.892 28.8H15.388C15.208 28.8 15.046 28.962 15.046 29.142V35.658ZM28.4107 33.768C28.4107 35.262 29.3827 36.18 30.7327 36.18C31.8487 36.18 32.5507 35.64 32.9467 35.262L33.1267 35.748C33.1987 35.928 33.2707 36 33.4327 36H33.9367C34.1167 36 34.2787 35.838 34.2787 35.658V31.824C34.2787 30.024 34.0627 28.62 31.7587 28.62C30.4267 28.62 29.4007 28.98 29.2747 29.034C29.1127 29.088 28.9867 29.214 29.0407 29.448L29.1847 30.114C29.2387 30.312 29.3647 30.456 29.5807 30.402C29.9587 30.294 30.7687 30.078 31.5967 30.078C32.5147 30.078 32.7307 30.528 32.7127 31.662C32.7127 31.662 32.0467 31.446 31.2907 31.446C29.4547 31.446 28.4107 32.454 28.4107 33.768ZM29.9767 33.75C29.9767 33.012 30.5707 32.562 31.4347 32.562C32.0827 32.562 32.5867 32.778 32.6947 32.85V34.002C32.4787 34.362 31.7947 34.902 31.0747 34.902C30.4087 34.902 29.9767 34.398 29.9767 33.75ZM37.372 25.866C37.966 25.866 38.434 25.398 38.434 24.822C38.434 24.228 37.966 23.76 37.372 23.76C36.796 23.76 36.346 24.228 36.346 24.822C36.346 25.398 36.796 25.866 37.372 25.866ZM36.544 35.658C36.544 35.838 36.706 36 36.886 36H37.912C38.092 36 38.254 35.838 38.254 35.658V29.142C38.254 28.962 38.092 28.8 37.912 28.8H36.886C36.706 28.8 36.544 28.962 36.544 29.142V35.658ZM40.587 35.658C40.587 35.838 40.749 36 40.929 36H41.955C42.135 36 42.297 35.838 42.297 35.658V23.742C42.297 23.562 42.135 23.4 41.955 23.4H40.929C40.749 23.4 40.587 23.562 40.587 23.742V35.658Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5183 71.32C28.5423 71.32 31.4223 67.128 31.4223 60.12C31.4223 53.112 28.5423 48.92 23.5183 48.92C18.4623 48.92 15.5823 53.112 15.5823 60.12C15.5823 67.128 18.4623 71.32 23.5183 71.32ZM23.5183 68.408C20.5103 68.408 18.8143 65.432 18.8143 60.12C18.8143 54.872 20.5103 51.864 23.5183 51.864C26.4943 51.864 28.1903 54.872 28.1903 60.12C28.1903 65.432 26.4943 68.408 23.5183 68.408Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 4.2002,
  y: 92.1523,
  width: 39,
  height: 16.8471,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgUnsubscribeKeg = function SvgUnsubscribeKeg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 109,
    viewBox: "0 0 48 109",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnsubscribeKeg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unsubscribe-keg.cb7e4247.svg";
export { ForwardRef as ReactComponent };